import { useCallback, useEffect, useRef, useState } from "react";

const MIN_WIDTH = 350;
const MOBILE_BREAKPOINT = 600;

export const useContainerWidth = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(MIN_WIDTH);

  const handleResize = useCallback(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(() => handleResize());
    observer.observe(element);
    handleResize();

    return () => observer.disconnect();
  }, [handleResize]);

  return { ref, width, isMobile: width < MOBILE_BREAKPOINT };
};
